export const FETCH_GARAGES_DATA = "FETCH_GARAGES_DATA";
export const FETCH_GARAGES_SUCCESS = "FETCH_GARAGES_SUCCESS";
export const FETCH_GARAGES_FAILURE = "FETCH_GARAGES_FAILURE";

export const FETCH_GARAGES_EDIT_DATA = "FETCH_GARAGES_EDIT_DATA";
export const FETCH_GARAGES_EDIT_SUCCESS = "FETCH_GARAGES_EDIT_SUCCESS";
export const FETCH_GARAGES_EDIT_FAILURE = "FETCH_GARAGES_EDIT_FAILURE";